export enum ConstantPortal {
  pagoPSE= '/pse-autoservicio-ref/consulta-pago',
  urlReturnPagoPse = 'tramites/comprobante-pago-pse'
}
